module.exports = {
      id: "icon-appstore-usage",
      viewBox: "0 0 189.408 63.551",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-appstore",
      toString: function () {
        return this.url;
      }
    }